<template>
    <fragment>
        <div :class="this.classValue" :data-label="Label ? labelCaption : null">
            <div class="input-group" dir="ltr">
                <b-form-input
                    type="text"
                    :id="RefCode"
                    :ref="refCode"
                    :dir="dirInput"
                    v-model="modelDescription"
                    @change="lookupFieldChange($event)"
                    @blur="lookupNameByCode($event.target.value)"
                    v-on:keyup.enter="lookupEnterEvent(refCode, $event.target.value)"
                    :disabled="IsDisabled"
                    :aria-describedby="RefCode"
                    :placeholder="Placeholder || $t('MdSelect.sOption')"
                    v-on:dblclick="CallModalTable()">
                </b-form-input>
                <input type="hidden" :value="modelCode">
                <div class="input-group-append">
                    <button
                        :disabled="IsDisabled"
                        class="btn btn-sm search-attached"
                        type="button"
                        v-on:click="CallModalTable()">
                        <i class="mdi mdi-magnify"></i>
                    </button>
                </div>
            </div>
        </div>

        <ModalTableMultiSelectServer
            v-if="ServerSidePagination"
            v-bind:Resource="this.ResourceParameter"
            v-bind:TypeOption="this.TypeOption"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="this.Fields"
            v-bind:FieldCode="this.fieldCode"
            v-bind:FieldDescription="this.fieldDescription"
            v-bind:TitleWindow="this.SearchTitle"
            v-bind:ModalId="this.modalId"
            v-bind:Stacked="this.Stacked"
            v-bind:AuxFields="this.AuxFields"
            v-bind:FieldsDate="this.FieldsDate"
            v-bind:ShowAddRecord="this.ShowAddRecord"
            v-bind:AddRecordLabel="this.AddRecordLabel"
            v-bind:BackToGridEventName="this.BackToGridEventName"
            v-bind:OkEventName="this.OkEventName"
            v-bind:valueToSearch="searchValueForModal"
            v-bind:ModelCode="this.ModelCode"
            v-bind:ReturnAll="this.ReturnAll"
        />
        <ModalTablePaginationClient
            v-else
            v-bind:Resource="this.ResourceParameter"
            v-bind:TypeOption="this.TypeOption"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="this.Fields"
            v-bind:FieldCode="this.fieldCode"
            v-bind:FieldDescription="this.fieldDescription"
            v-bind:TitleWindow="this.SearchTitle"
            v-bind:ModalId="this.modalId"
            v-bind:Stacked="this.Stacked"
            v-bind:AuxFields="this.AuxFields"
            v-bind:FieldsDate="this.FieldsDate"
            v-bind:ShowAddRecord="this.ShowAddRecord"
            v-bind:AddRecordLabel="this.AddRecordLabel"
            v-bind:BackToGridEventName="this.BackToGridEventName"
            v-bind:OkEventName="this.OkEventName"
            v-bind:valueToSearch="searchValueForModal"
            v-bind:ModelCode="this.ModelCode"
            v-bind:ReturnAll="this.ReturnAll"
        >
            <template v-if="$slots.body" v-slot:body>
                <slot name="body" />
            </template>
        </ModalTablePaginationClient>
    </fragment>
</template>

<script>

import ModalService from '@/services/modal.service'
import ShowMessage from "@/components/messages/ShowMessage.js";
import { EventBus } from '@/event-bus.js';
export default {
    name: 'MdLookupMultiSelect',
    mixins: [ShowMessage],
    props: {
        Label: String,
        ModelCode: Array,
        Placeholder: String,
        FieldDescription: String,
        FieldCode: String,
        IsDisabled: Boolean,
        RefCode: String,
        Api: String,
        GetValues: Function,
        InvalidFeedback: String,
        SearchTitle: String,
        SearchFieldCode: String,
        Fields: Array,
        AuxFields:Array,
        isValid:Boolean,
        isRequired:Boolean,
        Tag: String,
        Stacked:[Boolean],
        FieldsDate: Array,
        WrittenCodeisValid:Boolean,
        NoValidateChanges: Boolean,
        ShowAddRecord:Boolean,
        AddRecordLabel:String,
        BackToGridEventName:String,
        OkEventName:String,
        isConcatModalId:Boolean,
        ConcatModalId:String,
        classValueStyle:String,
        classValueInvalidStyle:String,
        ReturnAll: Boolean,
        ServerSidePagination: Boolean
    },
    computed: {
        Valid: function () {
            return this.message.split('').reverse().join('')
        },
        internalClassValueStyle(){
            return this.classValueStyle ? this.classValueStyle : "textlabel";
        },

        internalClassValueInvalidStyle(){
            return this.classValueInvalidStyle ? this.classValueInvalidStyle : "textlabel-invalid";
        },

        labelCaption() {
            return !this.isRequired ? this.Label+this.invalidFeedback : this.Label+' * '+this.invalidFeedback;
        },

        searchValueForModal() {
            if (this.modelCode && this.modelCode.length > 0) {
                return '';
            }
            return this.modelDescription || '';
        }
    },
    watch: {
        ModelCode: function(newModel) {
            if (newModel) {
                this.modelCode = newModel;
            }
        },

        ModelDescription: function(newModel) {
                this.modelDescription = newModel;
        },

        isValid: function (newValue) {
            this.setValid(newValue)
        }
    },
    data() {
        return {
            modelCode: this.ModelCode,
            ValidWrittenCode:false,
            modelDescription: this.ModelDescription,
            fieldCode: this.FieldCode ? this.FieldCode : "code",
            fieldDescription: this.FieldDescription ? this.FieldDescription : "description",
            invalidFeedback: "",
            lookupFieldChanged: false,
            FieldsParameter: [],
            ResourceParameter: "",
            TypeOption: "",
            refCode: this.RefCode ? this.RefCode : "",
            modalId: this.isConcatModalId ? this.RefCode+"_"+this.ConcatModalId :this.RefCode,
            parameter: {

            },
            classValue:this.classValueStyle ? this.classValueStyle : "textlabel",
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    },

    methods: {
        lookupFieldChange: function() {
            this.lookupFieldChanged = true;
        },

        setValid(value) {
            this.classValue= value ? this.internalClassValueStyle : this.internalClassValueInvalidStyle
            this.invalidFeedback = value ? "": ": "+ this.$t('Msg.InvalidCode')
        },

        setRequired(value) {
            this.isRequired = value;
            if (!value) {
                this.classValue= this.internalClassValueStyle
                this.invalidFeedback = ""
            }
        },

        lookupNameByCode: function(value) {
            if (this.lookupFieldChanged) {
                this.getLookup(value);
                this.lookupFieldChanged = false;
            }
        },

        getLookup(value) {
            if (value.length > 0) {
                if(this.SearchFieldCode) {
                    this.parameter[this.SearchFieldCode] = value;
                } else {
                    this.parameter.SearchCriteria = value;
                }
                ModalService.getAll("/" + this.Api, this.parameter)
                    .then((response) => {
                        if (response.status == '200' && response.data && response.data.length > 0) {
                            const item = response.data[0];
                            this.modelCode = [item[this.fieldCode]];
                            this.modelDescription = item[this.fieldDescription];
                            this.ValidWrittenCode = true;
                            EventBus.$emit('IsCorrectCode', true);
                            this.setValid(true);
                            if (this.GetValues) {
                                this.GetValues([item[this.fieldCode]]);
                            }
                        } else {
                            this.setValid(false);
                            this.ValidWrittenCode = false;
                            EventBus.$emit('IsCorrectCode', false);
                            this.modelCode = [];
                            if (this.GetValues) {
                                this.GetValues([]);
                            }
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.RetrieveInformation'), "error");
                        } else {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            } else {
                this.isRequired ? this.setValid(false) : this.setValid(true);
                this.modelCode = [];
                this.modelDescription = '';
                if (this.GetValues) {
                    this.GetValues([]);
                }
            }
        },

        // Fetches the display name for a single code and sets modelDescription (no GetValues side-effect)
        fetchDescriptionByCode(code) {
            const params = {};
            if (this.SearchFieldCode) {
                params[this.SearchFieldCode] = code;
            } else {
                params.SearchCriteria = code;
            }
            ModalService.getAll("/" + this.Api, params)
                .then((response) => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.modelDescription = response.data[0][this.fieldDescription];
                    }
                })
                .catch(() => {});
        },

        setDisplayText(codes) {
            if (codes.length > 1) {
                this.modelDescription = `${codes.length} ${this.$t('Shared.selected')}`;
            } else if (codes.length === 1) {
                this.fetchDescriptionByCode(codes[0]);
            } else {
                this.modelDescription = '';
            }
        },

        lookupEnterEvent: function() {
            this.CallModalTable();
        },

        CallModalTable: function() {
            if (this.refCode) {
                this.$emit('load', true);
                this.FieldsParameter = [
                    this.fieldCode,
                    this.fieldDescription
                ];
                this.ResourceParameter = "/" + this.Api;
                this.TypeOption = this.refCode;
                this.$bvModal.show(this.modalId);
                this.$emit('load', false);
            }
        },

        onCodeConditionOk(result) {
            this.modelCode = result;
            if (this.GetValues) {
                this.GetValues(result);
            }
            this.setDisplayText(result);
            this.setValid(true);
            this.ResourceParameter = "";
            this.$bvModal.hide(this.modalId);
        },

        onCodeConditionCancel(){
            this.ResourceParameter = "";
        },

    },

    mounted() {
        if (this.ModelCode && this.ModelCode.length > 0) {
            this.setDisplayText(this.ModelCode);
        }
    },

}

</script>
<style src="@/assets/css/clinical/multiselect.css">
@import "../../../assets/css/flex.css";
</style>
